import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Nutzungsbedingungen() {
  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-[#86868B] hover:text-[#1D1D1F] transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <div className="mt-6 bg-white rounded-2xl border border-[#E5E5EA] p-6 sm:p-8 space-y-6">
          <img src="/images/mib-logo-full.png" alt="MIB Logo" className="h-12 w-auto object-contain" />
          <h1 className="text-2xl sm:text-3xl font-bold text-[#1D1D1F]">Nutzungsbedingungen</h1>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">1. Geltungsbereich</h2>
            <p>
              Diese Nutzungsbedingungen gelten für die Nutzung der Dienste von Make It Media GmbH
              („Anbieter") im Zusammenhang mit der Plattform Make It Booking („Plattform"). Die Plattform
              umfasst die Buchungssoftware, das Dashboard, die öffentliche Buchungsseite sowie zugehörige
              Dienste unter den Domains booking.makeit-media.de, api.makeit-media.de und admin.makeit-media.de.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">2. Vertragspartner</h2>
            <p>Make It Media GmbH, Im Kohnental 2, 52353 Düren</p>
            <p>Handelsregister: HRB 9300, Amtsgericht Düren</p>
            <p>Vertreten durch: Celina Geraldes</p>
            <p>Kontakt: hello@makeit-media.de, +49 1573 3176758</p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">3. Leistungsumfang</h2>
            <p>
              Der Anbieter stellt eine Softwareplattform zur Verwaltung von Terminen, Kunden, Mitarbeitern,
              Leistungen und betriebsbezogenen Prozessen bereit. Der konkrete Leistungsumfang richtet sich
              nach dem gebuchten Tarif (Starter, Business, Pro) und den jeweils freigeschalteten Funktionen.
            </p>
            <p>Zu den Funktionen können u. a. gehören:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Online-Buchung und Kalenderverwaltung</li>
              <li>Kundenverwaltung (CRM) und Anamnese</li>
              <li>E-Mail- und SMS-Benachrichtigungen (Bestätigung, Erinnerung, Storno)</li>
              <li>Google-Kalender-Synchronisation</li>
              <li>Online-Zahlungen (Stripe Connect)</li>
              <li>E-Mail-Marketing und Kampagnen</li>
              <li>Gutscheine, Shop und Produktkatalog</li>
              <li>API und Webhooks</li>
              <li>Content-Bibliothek und Formulare</li>
            </ul>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">4. Registrierung und Nutzerkonto</h2>
            <p>
              Für die Nutzung ist ein Nutzerkonto erforderlich. Nutzer sind verpflichtet, wahrheitsgemäße
              Angaben zu machen und Zugangsdaten vertraulich zu behandeln. Der Anbieter behält sich vor,
              Konten bei Verstößen zu sperren oder zu löschen.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">5. Pflichten der Nutzer</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Keine rechtswidrigen Inhalte oder Handlungen über die Plattform,</li>
              <li>keine missbräuchliche oder sicherheitsgefährdende Nutzung,</li>
              <li>Beachtung gesetzlicher Vorgaben, insbesondere Datenschutz- und Wettbewerbsrecht,</li>
              <li>Einholung erforderlicher Einwilligungen bei Kunden (z. B. für E-Mail, SMS, Anamnese).</li>
            </ul>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">6. Vergütung und Laufzeit</h2>
            <p>
              Kostenpflichtige Leistungen richten sich nach den jeweils gültigen Preisen und Tarifbedingungen.
              Abonnements verlängern sich entsprechend der vereinbarten Laufzeit (monatlich/jährlich), sofern
              nicht fristgerecht gekündigt wird. Add-ons können separat gebucht werden.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">7. Online-Zahlungen, Gebühren und Rückerstattungen</h2>
            <p>
              Sofern der Nutzer die Funktion für Online-Zahlungen über den Zahlungsdienstleister Stripe (Stripe Connect) in seinem Profil aktiviert, gelten ergänzend die folgenden Bestimmungen:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Plattformgebühr:</strong> Für jede erfolgreiche Online-Zahlung eines Endkunden berechnet der Anbieter eine Service- und Systemgebühr („Plattformgebühr") in Höhe von <strong>2 % des Bruttobuchungswerts zuzüglich 0,20 €</strong> pro Transaktion. Die Zahlung des Endkunden erfolgt direkt über das eigene Stripe-Konto des Nutzers; die Plattformgebühr wird dabei automatisch als Anwendungsgebühr einbehalten, der verbleibende Betrag verbleibt auf dem Stripe-Konto des Nutzers.
              </li>
              <li>
                <strong>Stripe-Transaktionsgebühren:</strong> Zusätzlich zur Plattformgebühr fallen für jede Online-Zahlung die standardmäßigen Transaktionsgebühren des Zahlungsdienstleisters Stripe an. Diese werden direkt vom Stripe-Konto des Nutzers einbehalten und berühren das Konto des Anbieters nicht. Sie richten sich nach den Tarifen von Stripe (abhängig von Zahlungsart und Herkunftsland der Karte des Endkunden).
              </li>
              <li>
                <strong>Stornierungen und Rückerstattungen:</strong> Bei einer Rückerstattung – ob Voll- oder Teilrückerstattung – wird der anteilige Betrag der bereits einbehaltenen Plattformgebühr automatisch an den Nutzer zurückerstattet. Der Endkunde erhält stets den vollen Erstattungsbetrag. Eine zusätzliche Bearbeitungsgebühr fällt hierfür nicht an.
              </li>
              <li>
                <strong>Verrechnung negativer Salden (Shortfalls):</strong> In Ausnahmefällen – etwa wenn das Guthaben auf dem Stripe-Konto des Nutzers zum Zeitpunkt einer Rückerstattung nicht ausreicht – kann ein negativer Saldo entstehen. Dieser wird automatisch mit künftigen Zahlungseingängen des Nutzers verrechnet.
              </li>
            </ul>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">8. Kündigung</h2>
            <p>
              Beide Parteien können das Vertragsverhältnis gemäß den vereinbarten Fristen kündigen.
              Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt. Nach
              Vertragsende werden die Daten des Nutzers gemäß den gesetzlichen Vorgaben gelöscht oder
              anonymisiert.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">9. Haftung</h2>
            <p>
              Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie bei Verletzung
              von Leben, Körper und Gesundheit. Im Übrigen haftet der Anbieter nur bei Verletzung
              wesentlicher Vertragspflichten und begrenzt auf den vertragstypischen, vorhersehbaren Schaden.
              Die Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit nicht wesentliche
              Vertragspflichten verletzt werden.
            </p>
          </section>

          <section className="space-y-2 text-[#1D1D1F]">
            <h2 className="text-xl font-semibold">10. Schlussbestimmungen</h2>
            <p>
              Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist Düren, sofern
              der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
              Sondervermögen ist. Sollten einzelne Bestimmungen unwirksam sein oder werden, bleibt die
              Wirksamkeit der übrigen Bestimmungen unberührt.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
